jQuery( $ => {
	const $body = $( 'body' );

	// Checks if we're seeing a subscription product.
	const subscriptionIntervals = $( '.variations select.woo-variation-raw-select' );
	if ( subscriptionIntervals.length ) {
		displaySubscriptionPercentage( subscriptionIntervals );
	}

	/**
	 * Trigger accordion.
	 */
	$( '.product-block-content > h2 > button' ).on( 'click keydown', function( e ) {
		if ( e.type === 'click' || e.key === 'Enter' || e.key === ' ' ) {
			e.preventDefault();
			const $parentEl = $( this ).closest( '.product-block' );
			toggleProductBlock( $parentEl );
		}
	} );

	/**
	 * Toggles a product blocks accordion.
	 *
	 * @param {Object}  blockEl   the outer block element.
	 * @param {boolean} forceOpen whether it should be forced to open.
	 */
	function toggleProductBlock( blockEl, forceOpen = false ) {
		const trigger = blockEl.find( 'button' );
		const content = blockEl.find( '.product-block-inner-content' );

		// New state: forced open, or flip the current state.
		// hasClass('accordion-hidden') === currently closed === will open.
		const isOpen = forceOpen || blockEl.hasClass( 'accordion-hidden' );

		// Visual state: accordion-hidden present only when closed.
		blockEl.toggleClass( 'accordion-hidden', ! isOpen );

		// Accessibility state, all derived from isOpen.
		trigger.attr( 'aria-expanded', isOpen ? 'true' : 'false' );
		content.prop( 'inert', ! isOpen );
	}

	// Save the original product price html so it can be reset.
	const originalPrice = $( '.summary-inner-wrapper > .price' ).html();

	/**
	 * Make changes to the page whenever a change in the variations occurs.
	 * Show variation selection along with the label.
	 * Show the variations price instead of the price range.
	 */
	$body.on( 'found_variation', function( event, variation ) {
		setVariationPricing( variation );
	} );

	$body.on( 'reset_data', function() {
		resetVariationPrice();
	} );

	/**
	 * Changes the price displayed to that of the chosen variation.
	 *
	 * @param {Object} variation WooCommerce variation object
	 */
	function setVariationPricing( variation ) {
		let $priceEl = $( '.summary-inner-wrapper > .price' );

		if ( ! $priceEl.length ) {
			$priceEl = $( '.qala-quickview-product-container__right .price' );
		}

		if ( variation && variation.price_html ) {
			$priceEl.html( variation.price_html );
		}

		// Checks if we're seeing a subscription product.
		if ( subscriptionIntervals.length ) {
			displaySubscriptionPercentage( subscriptionIntervals );
		}
	}

	/**
	 * Reset the price when variation selection is cleared
	 */
	function resetVariationPrice() {
		const $priceEl = $( '.summary-inner-wrapper > .price' );

		if ( $priceEl.length ) {
			$priceEl.html( originalPrice );
		}
	}

	/**
	 * Toggles visibility on percentage discount label for the options that have it.
	 */
	function displaySubscriptionPercentage() {
		const selectedInterval = subscriptionIntervals.find( ':selected' ).val();

		$( '.subscription-product-content--sale-label' ).each( function() {
			const labelInterval = $( this ).attr( 'data-sub_interval' );
			$( this ).removeClass( 'active' );
			if ( selectedInterval === labelInterval ) {
				$( this ).addClass( 'active' );
			}
		} );
	}
} );
